import  { useState, useEffect } from "react";
import {
    Card,
    CardContent,
    Typography,
    Box,
    Grid,
    TextField,
    Button,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
} from "@mui/material";
import { apiUrl, backendHosts } from "../../../../ui-utils/apiConfig";
import axios from "axios";
import Swal from "sweetalert2";
const ResearchCreateForm = ({ categories, handleCloseCreateModal, loadData }) => {
    const [formData, setFormData] = useState({
        category_id: "",
        category_name: "",
        title: "",
        description: "",
        thumb_id: "",
        thumb_link: "",
        base64: "",
        filename: "",
    });

    const [filteredThumbnails, setFilteredThumbnails] = useState([]);


    const fetchThumbnail = async (id) => {

        try {
            const response = await axios.get(`${backendHosts.ADMIN}${apiUrl.getThumbnails}${id}`)
            // const response = await httpRequest({
            //   endPoint: `${backendHosts.ADMIN}${apiUrl.getAllBlogs}`,
            //   method: "get",
            //   instance: "instanceOne",
            // });
            // return response.data?.data;
            console.log("thum", response.data.data.data)
            setFilteredThumbnails(response.data.data.data)
        } catch (error) {
            throw new Error(error.message);
        }
    }

    /** Handle Category Change */
    const handleCategoryChange = (e) => {
        const selectedId = e.target.value;
        const selectedCategory = categories.find((cat) => cat.id === selectedId);

        setFormData((prev) => ({
            ...prev,
            category_id: selectedId,
            category_name: selectedCategory?.category_name || "",
            thumb_id: "",
            thumb_link: "",
        }));
        fetchThumbnail(selectedId)
    };

    /** Handle Input Change */
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    /** Handle Thumbnail Selection */
    const handleThumbnailSelect = (thumb) => {
        console.log("thumb", thumb.image_link)
        setFormData((prev) => ({
            ...prev,
            thumb_id: thumb.id,
            thumb_link: thumb.image_link,
        }));
    };

    /** Handle PDF Upload and Convert to Base64 */
    const handlePdfUpload = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setFormData((prev) => ({
                    ...prev,
                    filename: file.name,
                    base64: reader.result,
                }));
            };
            reader.readAsDataURL(file);
        }
    };

    /** Handle Submit */
    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log("Submitting data:", formData);

        try {
            const payload = {
                data: {
                    category_id: formData.category_id,
                    title: formData.title,
                    description: formData.description,
                    thumb_id: formData.thumb_id,
                    type: formData.category_name,
                    base64: formData.base64
                }
            }
            console.log("create Payload", payload)

            const response = await axios.post(`${backendHosts.ADMIN}${apiUrl.createResearh}`,payload)

            if (response?.data?.data?.success && response?.data?.data?.status == 200) {
                handleCloseCreateModal()
                loadData()
                Swal.fire({
                    html: `<h2 style="font-size: 24px; font-family: 'cardiuma-regular' !important;">
                                Updated Successfully!
                            </h2>`,
                    icon: "success",
                    willOpen: () => {
                        const swalContainer = document.querySelector(".swal2-container");
                        if (swalContainer) {
                            swalContainer.style.zIndex = "2000";
                        }
                    },
                });
            }
        } catch (error) {
            console.log("error", error.message);
            Swal.fire({
                icon: "Somthing Went Wrong",
                title: "Oops...",
                html: `<p style="font-size: 24px ; fontFamily:'cardiuma-regular', sans-serif !important;">${error.message}!</p>`,
                text: `!`,
                willOpen: () => {
                    const swalContainer = document.querySelector(".swal2-container");
                    if (swalContainer) {
                        swalContainer.style.zIndex = "2000"; // Apply the desired z-index
                    }
                },
            });
        }




    };

    /** Validation for enabling Submit button */
    const isFormValid =
        formData.category_id &&
        formData.title &&
        formData.description &&
        formData.thumb_id &&
        formData.base64;

    return (
        <Card sx={{ maxWidth: 800, margin: "0 auto", mt: 4, borderRadius: 2, boxShadow: 3 }}>
            <CardContent>
                <Typography variant="h5" gutterBottom>
                    Create New Research
                </Typography>

                <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
                    <Grid container spacing={3}>
                        {/* Category Dropdown */}
                        <Grid item xs={12}>
                            <FormControl fullWidth required>
                                <InputLabel>Category</InputLabel>
                                <Select
                                    name="category_id"
                                    value={formData.category_id}
                                    onChange={handleCategoryChange}
                                    label="Category"
                                >
                                    {categories.map((cat) => (
                                        <MenuItem key={cat.id} value={cat.id}>
                                            {cat.category_name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>

                        {/* Title */}
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                name="title"
                                label="Title"
                                variant="outlined"
                                value={formData.title}
                                onChange={handleChange}
                                required
                            />
                        </Grid>

                        {/* Description */}
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                name="description"
                                label="Description"
                                variant="outlined"
                                value={formData.description}
                                onChange={handleChange}
                                multiline
                                rows={4}
                                required
                            />
                        </Grid>

                        {/* Thumbnail Selection */}
                        {filteredThumbnails.length > 0 && (
                            <Grid item xs={12}>
                                <Typography variant="subtitle1" gutterBottom>
                                    Select a Thumbnail
                                </Typography>
                                <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
                                    {filteredThumbnails.map((thumb) => (
                                        <Box
                                            key={thumb.id}
                                            onClick={() => handleThumbnailSelect(thumb)}
                                            sx={{
                                                border: formData.thumb_id === thumb.id ? "2px solid #1976d2" : "2px solid transparent",
                                                borderRadius: 2,
                                                cursor: "pointer",
                                                overflow: "hidden",
                                                width: 80,
                                                height: 80,
                                                transition: "border 0.2s",
                                            }}
                                        >
                                            <img
                                                src={thumb.image_link}

                                                style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                            />
                                        </Box>
                                    ))}
                                </Box>
                            </Grid>
                        )}

                        {/* PDF Upload */}
                        <Grid item xs={12}>
                            <Button variant="outlined" component="label">
                                Upload PDF
                                <input
                                    type="file"
                                    hidden
                                    accept="application/pdf"
                                    onChange={handlePdfUpload}
                                />
                            </Button>

                            {formData.filename && (
                                <Box mt={1}>
                                    <Typography variant="subtitle2">
                                        Selected File: {formData.filename}
                                    </Typography>
                                </Box>
                            )}
                        </Grid>

                        {/* Submit Button */}
                        <Grid item xs={12}>
                            <Button
                                type="submit"
                                variant="contained"
                                fullWidth
                                disabled={!isFormValid}
                                sx={{
                                    backgroundColor: "#6cd13d99",
                                    "&:hover": { backgroundColor: "#6cd13d99" },
                                }}
                            >
                                Create
                            </Button>
                        </Grid>
                    </Grid>
                </Box>
            </CardContent>
        </Card>
    );
};

export default ResearchCreateForm;
